import * as Models from "../../Models";
import * as Services from "../../Services";
import * as Routes from "../../Routes";
import * as Common from "../../Common/modules";
import * as toastr from "toastr";
import * as _ from "lodash";
    export interface ICreateNoteModalScope extends ng.IScope {
        createNoteModalCtrl: CreateNoteModalCtrl;
    }

    export class CreateNoteModalCtrl {
        public customerNote: Models.Customer.CustomerNoteModel.ICustomerNoteModel;
        public possibleNoteTypes: string[];
        public latestNotes: Models.Customer.SolarNoteResponse.ISolarNoteResponse;

        public static $inject = ['$scope', '$modalInstance', 'CustomerApiClient', 'passedInCustomer'];

        constructor($scope: ICreateNoteModalScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
            public passedInCustomerNumber: string) {

            $scope.createNoteModalCtrl = this;

            this.customerApiClient.getNoteTypes().then((result: string[]) => {
                this.possibleNoteTypes = result;
            });
        }

        public submit = () => {
            this.customerNote.customerNumber = this.passedInCustomerNumber;
            this.submitNoteCreation();
        }

        public submitNoteCreation = (): void => {
            this.customerApiClient.submitNoteCreation(this.customerNote).then(() => {
                this.$modalInstance.close();
            });
        }
    }
